import React from "react";

import Decimal from "decimal.js";

import * as utils from "@client/utils";

import {server} from "@reactivated";

export const Template = (props: server.manager.templates.WeeklySummaryEmail) => {
    const clients = props.clients.map((client) => {
        const measurements = [
            client.primary_metric,
            client.secondary_metric,
            client.tertiary_metric,
        ]
            .map((metric) => {
                if (metric == null) {
                    return null;
                }

                if (metric.value == null) {
                    return `- ${metric.metric.label} was not logged`;
                }

                const current = utils.formatDecimalAndUnit(
                    new Decimal(metric.value).toDecimalPlaces(1),
                    metric.metric.type,
                    client.client_manager.client.profile.is_imperial,
                );

                if (metric.previous != null && metric.delta != null) {
                    const previous = utils.formatDecimalAndUnit(
                        new Decimal(metric.previous).toDecimalPlaces(1),
                        metric.metric.type,
                        client.client_manager.client.profile.is_imperial,
                    );
                    const delta = utils.formatDecimalAndUnit(
                        new Decimal(metric.delta).toDecimalPlaces(1),
                        metric.metric.type,
                        client.client_manager.client.profile.is_imperial,
                    );

                    return `- ${metric.metric.label} changed ${delta} from ${previous} to ${current}`;
                }

                return `- ${metric.metric.label} was ${current}`;
            })
            .filter((result): result is NonNullable<typeof result> => result != null);

        return [
            `### ${client.client_manager.name} — ${client.client_manager.client.email}`,
            `- Last seen ${utils.formatDistanceToNow(client.last_seen)} ago`,
            `- Logged food ${
                client.statuses.filter((status) => status.logged_entries).length
            } / ${client.statuses.length} days`,
            `- Worked out ${
                client.statuses.filter((status) => status.logged_workout).length
            } / ${client.statuses.length} days`,
            `- Hit targets ${
                client.statuses.filter((status) => status.status == "success").length
            } / ${client.statuses.length} days`,
            `- Weighed in ${
                client.statuses.filter((status) => status.weighed_in).length
            } / ${client.statuses.length} days`,
            ...measurements,
        ].join("\n");
    });

    const email = [
        `Dear ${props.manager_name},`,
        `Below is a weekly report of your clients.`,
        ...clients,
        `Have feedback or would like to see something else on this report? Reply to this email or [contact us](https://www.joyapp.com/contact/)!`,
        `Best,`,
        `The Joy Team`,
    ];

    return <div id="email">{email.join("\n\n")}</div>;
};
